const getLocaleCodeWithoutRegion = locale => {
  return locale.toLowerCase().split(/[_-]+/)[0] || 'en';
};
const getRegionCodeFromLocale = (locale = '',
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
defaultLoggedOutConfig = {}, fallbackLoggedOutConfig) => {
  // If there's no locale in url or the locale is a fallback locale
  if (!locale || fallbackLoggedOutConfig.includes(locale)) {
    return 'US';
  }

  // If there's no delimiter, then it is a default_single_path locale
  const country = locale.split('-')[1] || locale;
  if (defaultLoggedOutConfig[country]) {
    return defaultLoggedOutConfig[country].country_code;
  }
  return 'US';
};
export { getRegionCodeFromLocale as default, getLocaleCodeWithoutRegion, getRegionCodeFromLocale };
//# sourceMappingURL=splitLocale.js.map
